<template>
    <div class="box">
        <div class="title">任务数</div>
        <div class="item">
            <p class="name">
                今日
            </p>
            <p class="count">
                {{ toThousands(today) }}
            </p>
        </div>
        <div class="item">
            <p class="name">
                昨日
            </p>
            <p class="count">
                {{ toThousands(yestoday) }}
            </p>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'dutyNum',
    props:{
      today: {
        type: Number,
        default: 0
      },
      yestoday: {
        type: Number,
        default: 0
      },
    },
    methods: {
      toThousands(num) {
        var result = [], counter = 0
        num = (num || 0).toString().split('')
        for (var i = num.length - 1; i >= 0; i--) {
          counter++
          result.unshift(num[i])
          if (!(counter % 3) && i !== 0) {
            result.unshift(',')
          }
        }
        return result.join('')
      }
    }
  }
</script>

<style scoped lang="less">
    .box {
        height: 160px;
        background: #fff;
        border-radius: 4px;
        padding: 20px 30px;
        position: relative;
        .title{
            font-size: 16px;
            color: #999;
            margin-bottom: 10px;
        }
    }

    .item {
        height: 42px;
        background: #F1F7FF;
        display: flex;
        line-height: 42px;
        justify-content: space-between;
        padding: 0 15px;
        margin-bottom: 8px;
        .name{
            color: #3C93FF;
        }
        .count{
            color: #333;
            font-size: 24px;
            font-weight: 500;
        }
    }
</style>
